/**
 * NavaWordmark — marca da solução no splash, login e MFA.
 *
 * Desde o visual Sphere (2026-10) mostra a marca "Sphere" proposta no pacote de
 * design (decisão do dono), no lugar do lockup Nava. O nome do componente fica
 * para não mexer nos consumidores.
 * `size` (base em px, equivale ao antigo font-size) controla a altura:
 *   login: size=56 → ~190 px · splash: size=64 → ~218 px.
 * Abaixo da marca Sphere, centralizado, vai o logo institucional da NAVA (somado, não no
 * lugar dela).
 */
import { SphereBrand } from '@/ui/sphere/SphereBrand';
import { NavaLogo } from '@/ui/sphere/NavaLogo';

export function NavaWordmark({ size = 24 }) {
  const h = Math.round(size * 3.4);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: Math.round(h * 0.06) }}>
      <SphereBrand size={h} />
      <NavaLogo largura={Math.round(h * 0.6)} />
    </div>
  );
}
